module.exports = __webpack_public_path__ + "img/Logo_Hyundai.5b49c734.svg";